import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export const DefaultRedirect: React.FC = () => {
  const { sidebarData, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Get the first allowed route from sidebar data
  const firstAllowedRoute = sidebarData?.allowed_routes?.[0];

  // Default fallback routes in order of preference
  const fallbackRoutes = ["/customers", "/dashboard", "/surveillance"];

  // Find the first available fallback route that user has access to
  const fallbackRoute = fallbackRoutes.find((route) =>
    sidebarData?.allowed_routes?.includes(route),
  );

  // Use the first allowed route, or fallback, or default to customers
  const redirectTo = firstAllowedRoute || fallbackRoute || "/customers";

  return <Navigate to={redirectTo} replace />;
};
